module.exports = __webpack_public_path__ + "img/60.5.COD.3329a7a8.png";